import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminAnalyticsPage from "./pages/AdminAnalyticsPage";
import UserManagementPage from "./pages/UserManagementPage";
import CreatorCRMPage from "./pages/CreatorCRMPage";
import OpportunitiesHubPage from "./pages/OpportunitiesHubPage";
import SupportTicketsPage from "./pages/SupportTicketsPage";
import SystemUsersPage from "./pages/SystemUsersPage";
import FinancePage from "./pages/FinancePage";
import SettingsPage from "./pages/SettingsPage";
import RolesPermissionsPage from "./pages/RolesPermissionsPage";
import ModerationQueuePage from "./pages/ModerationQueuePage";
import InventoryPage from "./pages/InventoryPage";
import AuditLogsPage from "./pages/AuditLogsPage";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminDashboardPage />} />
        <Route path="analytics" element={<AdminAnalyticsPage />} />
        
        {/* Identity Management */}
        <Route path="identity">
          <Route path="fans" element={<UserManagementPage />} />
          <Route path="creators" element={<CreatorCRMPage />} />
          <Route path="system" element={<SystemUsersPage />} />
        </Route>

        {/* Monetization Hub - Separate pages for each type */}
        <Route path="monetization">
          <Route path="ads" element={<OpportunitiesHubPage type="ads" />} />
          <Route path="affiliates" element={<OpportunitiesHubPage type="affiliates" />} />
          <Route path="donations" element={<OpportunitiesHubPage type="donations" />} />
          <Route path="inventory" element={<InventoryPage />} />
        </Route>

        {/* System */}
        <Route path="finance" element={<FinancePage />} />
        <Route path="support" element={<SupportTicketsPage />} />
        <Route path="moderation" element={<ModerationQueuePage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="roles" element={<RolesPermissionsPage />} />
        <Route path="audit" element={<AuditLogsPage />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
